import api from './api';

export interface SkillContainer {
  id: number;
  title: string;
  parent: number | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  children_count: number;
  skills_count: number;
}

class SkillContainerService {
  async getContainers(parentId: number | null = null): Promise<SkillContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/skill-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<SkillContainer> {
    const response = await api.get(`/skill-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: SkillContainer[], skills: any[] }> {
    const response = await api.get(`/skill-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<SkillContainer>): Promise<SkillContainer> {
    const response = await api.post('/skill-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<SkillContainer>): Promise<SkillContainer> {
    const response = await api.patch(`/skill-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/skill-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/skill-containers/reorder/', { items });
  }
}

const skillContainerService = new SkillContainerService();
export default skillContainerService;
